<template>
    <div v-if="user">
        <va-page-header>
            <div slot="title">
                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>

                {{ _(sectionCapitalized + ' Reports') }}
            </div>

        </va-page-header>
        <div v-if="allFiltersCount !== 0">
            <va-row :gutter="12">
                <va-column :lg="12" :sm="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Title') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                        _('Created By') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Category') }}
                                    </th>
                                    <!-- <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Sidebar') }}
                                    </th> -->
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">
                                        {{ _('Actions') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="filter in perPageFilters">
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <a style="cursor:pointer" @click="navigate(filter.get('url'))">{{
                                            g_getLabel(filter) }}</a></td>
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        {{ filter.get('createdBy')!=null ? filter.get('createdBy').get('name') : 'n/a' }}
                                    </td>
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        {{ g_getLabel(filter.get('category')) }}
                                    </td>
                                    <!-- <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <va-checkbox @change="changeShowInSidebar(filter)"
                                            :label="filter.get('show_in_sidebar').toString()"
                                            :checked="filter.get('show_in_sidebar')"></va-checkbox>
                                    </td> -->
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <va-tooltip :content="_('delete')" trigger="hover" placement="top">
                                            <va-icon class="actions_btn" type="trash-alt" color="gray"
                                                @click.native="deleteObject(filter)"></va-icon>
                                        </va-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </va-table>
                </va-column>
            </va-row>
            <va-row :gutter="12">
                <va-column :lg="6" :sm="6">
                    <div style="display: flex">
                        <v-page :class="{no_click: allFiltersCount==0}" :key="$route.path" :total-row="allFiltersCount"
                            @page-change="paginate"></v-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({pageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>
            </va-row>
        </div>
        <div v-else class="deadCenter">
            <p>{{ _('No reports available') }}</p>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";

    export default {
        data() {
            return {
                page: 1,
                allFiltersCount: 0,
                perPageFilters: [],
                sectionCapitalized: '',
                section: '',
            }
        },


        computed: {
            ...mapGetters(["user", "getSystemLanguage", "loading", "getDirectionStatus", "getUserDepartmentsFromState"]),

            pageNumbers() {
                if (this.allFiltersCount <= 10) return 1
                else return Math.ceil(this.allFiltersCount / 10)
            },
        },


        methods: {
            ...mapActions(['fetchSidebarReports']),

            deleteObject(object) {
                this.g_deleteObject(object)
                    .then(async result => {
                        if (result) {
                            this.$store.commit('setLoading', true)
                            // this.fetchSidebarReports()
                            await this.fetchSectionFilters(this.page)
                            await this.fetchSectionFiltersCount()
                        }
                    }).catch(e => {

                    })
            },

            changeShowInSidebar(filter) {
                filter.set('show_in_sidebar', !filter.get('show_in_sidebar'))
                filter.save()
                    .then(async res => {
                        await this.g_newActivity({
                            label_english: res.get('label_english'),
                            label_pashto: res.get('label_pashto'),
                            label_dari: res.get('label_dari'),
                            type: 'filter',
                            action: 'editSidebar',
                            url: this.$route.path,
                            createdBy: this.user.id,
                            to: null,
                            category: res.get('category'),
                            department: res.get('department'),
                            class: 'Filter',
                            reference_id: this.section == 'survey' && res.get('form') != null ? res.get('form').id : ''
                        })
                        // this.fetchSidebarReports()
                    })
            },

            deleteFilter(filter) {
                var self = this
                this.VaModal.confirm({
                    title: self._('Alert'),
                    message: self._('Please make sure if you want to delete this filter'),
                    type: 'warning',
                    onConfirm() {
                        filter.delete().then(() => {
                            self.fetchSectionFilters(self.page)
                            self.$notify({
                                group: 'foo',
                                text: self._('Filter was deleted'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            });
                        }).catch(e => {
                            self.$notify({
                                group: 'foo',
                                title: self._('Error'),
                                text: self._('An error was encountered during deleting filter'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        })
                    }
                })
            },

            async fetchSectionFilters(pageNumber) {
                var conditions = [];
                conditions.push(new Parse.Query('Filter').equalTo('type', this.section));
                if (!this.user.get('roles').includes('admin')) {
                    var tempDepartments = [];
                    if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                        for (const key in this.getUserDepartmentsFromState) {
                            if (this.getUserDepartmentsFromState[key]) {
                                tempDepartments.push(makePointer('Department', this.getUserDepartmentsFromState[key].id))
                            }
                        }
                    }
                    var temp = [];
                    temp.push(new Parse.Query('Filter').containedIn('department', tempDepartments));
                    temp.push(new Parse.Query('Filter').equalTo('department', null));
                    conditions.push(Parse.Query.or(...temp))
                }

                var mainQuery = Parse.Query.and(...conditions);
                mainQuery.skip((pageNumber - 1) * 25)
                mainQuery.limit(25)
                mainQuery.descending('createdAt')
                mainQuery.include('category')
                mainQuery.include('createdBy')
                mainQuery.include('department')
                this.perPageFilters = await mainQuery.find()
                this.$store.commit('setLoading', false)
            },

            async fetchSectionFiltersCount() {
                var conditions = [];
                conditions.push(new Parse.Query('Filter').equalTo('type', this.section));
                if (!this.user.get('roles').includes('admin')) {
                    var tempDepartments = [];
                    if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                        for (const key in this.getUserDepartmentsFromState) {
                            if (this.getUserDepartmentsFromState[key]) {
                                tempDepartments.push(makePointer('Department', this.getUserDepartmentsFromState[key].id))
                            }
                        }
                    }
                    var temp = [];
                    temp.push(new Parse.Query('Filter').containedIn('department', tempDepartments));
                    temp.push(new Parse.Query('Filter').equalTo('department', null));
                    conditions.push(Parse.Query.or(...temp))
                }

                var mainQuery = Parse.Query.and(...conditions);
                this.allFiltersCount = await mainQuery.count()
                // let q = new Parse.Query('Filter')
                // q.equalTo('type', this.section)
                // if (!this.user.get('roles').includes('admin')) {
                //     // q.equalTo('department', this.user.get('department').id)
                //     var tempDepartments = [];
                //     if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                //         for (const key in this.getUserDepartmentsFromState) {
                //             if (this.getUserDepartmentsFromState[key]) {
                //                 tempDepartments.push(makePointer('Department', this.getUserDepartmentsFromState[key].id))
                //             }
                //         }
                //     }
                //     q.containedIn('department', tempDepartments);
                // }
                // this.allFiltersCount = await q.count()
            },

            navigate(to) {
                this.$router.push(to);
            },

            async paginate(page) {
                this.$store.commit('setLoading', true)
                await this.fetchSectionFilters(page.pageNumber)
            },
        },


        async mounted() {
            this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
            this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
            this.$store.commit('setLoading', true)
            await this.fetchSectionFiltersCount();
            await this.fetchSectionFilters(1)
            this.$store.commit('setLoading', false)
        }
    };
</script>

<style>
</style>